(function(angular, schoolwork12) {
'use strict';
angular.module(schoolwork12.app.manageSchoolData.name)
    .factory(schoolwork12.app.manageSchoolData.services.schoolDataEditSvc, ['$http', '$q', '$rootScope', function ($http, $q, $rootScope) {

         var getClassroomDates = function (keycode, schoolId) {
                 console.info('In getClassroomDates service');
                 console.info('Making a call to service');
                 var clasroomDates = null;
                 var deferred = $q.defer();
                 var request = $http({  
                     method: 'GET',
                     url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + schoolId +'/classroomDates',
                     headers: {
                         'Content-Type': 'application/json',
                         'X-API-TOKEN': keycode
                     }
                 });
                 request.then(function (response) {
                     clasroomDates = response.data;
                     deferred.resolve(clasroomDates);
                     console.info('Got the school classroom dates');
                 }, function (error) {  
                     deferred.reject(error);
                 });
                 return deferred.promise;
            };


         var saveSchoolDataDetails = function(keycode, schoolId, classroomDatesCreate , classroomDatesDelete, classroomIdList ){
                 console.info('In saveSchoolDataDetails service');
                 console.info('Making a call to service');
                 var result = null;
                 var deferred = $q.defer();
                 var data = {
                        createDateList: [],
                        deleteDateList: [],
                        classroomIdList: []
                 };
                 data.createDateList = classroomDatesCreate;
                 data.deleteDateList = classroomDatesDelete;
                 data.classroomIdList = classroomIdList;
                 var request = $http({
                    method: 'POST',
                    url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint  + schoolId +'/classroomDates',
                    data : data,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN' : keycode
                    }
                 });
                 request.then(function (response) {
                    result = response.data;
                    deferred.resolve(result);
                    $rootScope.editErrorOccurred =false;
                    $rootScope.showSavedDataFieldsMsg = true;
                    console.info('Saved school data details');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
         };

        var searchDeactivatedClassrooms = function(keycode, schoolId, deactClassName, deactClassID, deactCourseOffID, deactDate) {
            console.info('In searchDeactivatedClassrooms service');
            console.info('Making a call to service');
            var deactClassrooms = null;
            var deferred = $q.defer();
            var data = {
                deactClassName: deactClassName,
                deactClassID: Number(deactClassID) || null,
                deactCourseOffID: Number(deactCourseOffID) || null,
                deactDate: deactDate
            }
            var request = $http({  
                method: 'POST',
                url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + schoolId +'/deactClassrooms',
                data: data,
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-TOKEN': keycode
                }
            });
            request.then(function (response) {
                deferred.resolve(response.data);
                console.info('Got the school deactivated classrooms.');
            }, function (error) {  
                deferred.reject(error);
            });
            return deferred.promise;
        };

        var getDataFields = function (keycode, schoolId) {
                 console.info('In getDataFields service');
                 console.info('Making a call to service');
                 var dataFields = null;
                 var deferred = $q.defer();
                 var request = $http({  
                     method: 'GET',
                     url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + schoolId +'/dataFields',
                     headers: {
                         'Content-Type': 'application/json',
                         'X-API-TOKEN': keycode
                     }
                 });
                 request.then(function (response) {
                     dataFields = response.data;
                     deferred.resolve(dataFields);
                     console.info('Got the school data fields');
                 }, function (error) {  
                     deferred.reject(error);
                 });
                 return deferred.promise;
            };

            var getSchoolMessageFieldTemplates = function (keycode, schoolId) {
                console.info('In getDataFields service');
                console.info('Making a call to service');
                var dataFields = null;
                var deferred = $q.defer();
                var request = $http({ 
                    cache:true,
                    method: 'GET',
                    url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + schoolId +'/messageFieldTemplates',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    dataFields = response.data;
                    deferred.resolve(dataFields);
                    console.info('Got the school data fields');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
           };

           
         var saveSchoolDataFields = function(keycode, schoolId, dataFieldList){
                 console.info('In saveSchoolDataFields service');
                 console.info('Making a call to service');
                 var result = null;
                 var deferred = $q.defer();
                 var data = {
                        dataFieldList: [],
                        // tagsRemovedList: []
                 };
                 data.dataFieldList = dataFieldList;
                 // data.tagsRemovedList = tagsRemovedList;

                 var request = $http({
                    method: 'POST',
                    url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint  + schoolId +'/dataFields',
                    data : data,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN' : keycode
                    }
                 });
                 request.then(function (response) {
                    result = response.data;
                    deferred.resolve(result);
                    console.info('Saved school data fields');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
         };

             var saveSchoolCTEPrograms = function(keycode, schoolId, cteFieldList){
                 console.info('In saveSchoolCTEPrograms service');
                 console.info('Making a call to service');
                 var result = null;
                 var deferred = $q.defer();
                 var data = cteFieldList;
                 var request = $http({
                    method: 'POST',
                    url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint  + schoolId +'/schoolCTEPrograms/',
                    data : data,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN' : keycode
                    }
                 });
                 request.then(function (response) {
                    result = response.data;
                    deferred.resolve(result);
                    console.info('Saved school CTE fields');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
         };

            var getAllGradesList = function (keycode, schoolId) {
                console.info('In get Grades service call');
                console.info('Making a call to service');
                var allGradesList = null;
                var deferred = $q.defer();
                var request = $http({
                    // cache:true,
                    method: 'GET',
                    url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + schoolId + '/schoolGradeMarkSets/',
                    // url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + schoolId + '/gradeMarkSets/' + gradeMarkId,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    console.info('Got all active grades list');
                    allGradesList = response.data;
                    deferred.resolve(allGradesList);
                }, function (error) {
                    console.info("Error occured while getting list of grade service");
                    deferred.reject(error);
                });
                return deferred.promise;
            };
            var getAllGradesDetails = function (keycode, schoolId, grademarkSetId) {
                console.info('In get Grades Details service call');
                console.info('Making a call to service');
                var allGradesList = null;
                var deferred = $q.defer();
                var request = $http({
                    // cache:true,
                    method: 'GET',
                    url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + schoolId + '/gradeMarkSets/' + grademarkSetId,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    console.info('Got details of grademark set');
                    allGradesList = response.data;
                    deferred.resolve(allGradesList);
                }, function (error) {
                    console.info("Error occured while getting grade details service");
                    deferred.reject(error);
                });
                return deferred.promise;
            };

        var saveSchoolGradeMarkSets = function(keycode, schoolId,  data){
            console.info('In save Grade details service call');
            console.info('Making a call to service');
            var result = null;
            var deferred = $q.defer();
            var request = $http({ 
                method: 'PUT',
                url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + schoolId +'/saveSchoolGradeMarkSets/' + data.gradeMarkSetId ,
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-TOKEN': keycode
                },
                data: data
            });
            request.then(function (response) {
                result = response.data;
                deferred.resolve(result);
                console.info('Save the GradeMarkSets');
            }, function (error) {  
                deferred.reject(error);
            });
            return deferred.promise;
        }

        var getAllSchoolYear = function(keycode, schoolId){
            console.info('In get SchoolYears service call');
            console.info('Making a call to service');
            var allSchoolYear = null;
                var deferred = $q.defer();
                var request = $http({
                    // cache:true,
                    method: 'GET',
                    url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + schoolId + '/schoolYears',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    console.info('Got details of schoolYears');
                    allSchoolYear = response.data;
                    deferred.resolve(allSchoolYear);
                }, function (error) {
                    console.info("Error occured while getting School Years details service");
                    deferred.reject(error);
                });
                return deferred.promise;
        };

        var getSchoolTerms = function(keycode){
            console.info('In get SchoolTerms service call');
            console.info('Making a call to service');
            var schoolTerms = null;
                var deferred = $q.defer();
                var request = $http({
                    // cache:true,
                    method: 'GET',
                    url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + 'terms',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    console.info('Got details of School Terms');
                    schoolTerms = response.data;
                    deferred.resolve(schoolTerms);
                }, function (error) {
                    console.info("Error occured while getting School  Terms details service");
                    deferred.reject(error);
                });
                return deferred.promise;
        };

        // This method is to retrieve schoolTerms related to school year.
        var getXschSchTerms = function(keycode, schoolId, year){
            console.info('In get SchoolTerms service call');
            console.info('Making a call to service');
            var schoolTerms = null;
                var deferred = $q.defer();
                var request = $http({
                    // cache:true,
                    method: 'GET',
                    url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + schoolId + '/schoolTerm/' + year,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    console.info('Got details of School Terms');
                    schoolTerms = response.data;
                    deferred.resolve(schoolTerms);
                }, function (error) {
                    console.info("Error occured while getting School  Terms details service");
                    deferred.reject(error);
                });
                return deferred.promise;
        };

        // This method is to retrieve schoolTerms related to school.
        var getXschSchTermsBySchool = function(keycode, schoolId){
            console.info('In get SchoolTerms service call');
            console.info('Making a call to service');
            var schoolTerms = null;
                var deferred = $q.defer();
                var request = $http({
                    // cache:true,
                    method: 'GET',
                    url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + schoolId + '/schoolTerms',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    console.info('Got details of School Terms');
                    schoolTerms = response.data;
                    deferred.resolve(schoolTerms);
                }, function (error) {
                    console.info("Error occured while getting School  Terms details service");
                    deferred.reject(error);
                });
                return deferred.promise;
        };

        // This method is to retrieve schoolCourses related to school year and term.
        var getXschSchCourses = function(keycode, schoolId, year, term, duplicateToSchoolId){
            console.info('In get SchoolCourses service call');
            console.info('Making a call to service');
            var schoolCourses = null;
            //STT-8374: STT.7803e.2 Courses are pulled into the term's catalog from the catalog being duplicated
            var endPoindToDuplicate = typeof (duplicateToSchoolId) !== 'undefined' ? `?duplicateTo=${duplicateToSchoolId}` : "";
                var deferred = $q.defer();
                var request = $http({
                    // cache:true,
                    method: 'GET',                                  
                    url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + schoolId + '/catalogCourses/' + 
                        year + '/' + term + endPoindToDuplicate,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    console.info('Got details of School Courses');
                    schoolCourses = response.data;
                    deferred.resolve(schoolCourses);
                }, function (error) {
                    console.info("Error occured while getting School Courses details service");
                    deferred.reject(error);
                });
                return deferred.promise;
        };

        // This method is to retrieve grades related to school year and term.
        var getXschSchGrades = function(keycode, schoolId, year, term){
            console.info('In get school grades service call');
            console.info('Making a call to service');
            //STT-8800: fetch grades for school year and term
            var schoolGrades = null;
            var deferred = $q.defer();
            var request = $http({
                method: 'GET',
                url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + schoolId + '/grades/' + year + '/' + term,
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-TOKEN': keycode
                }
            });
            request.then(function (response) {
                console.info('Got all grades for school year and term');
                schoolGrades = response.data;
                deferred.resolve(schoolGrades);
            }, function (error) {
                console.info("Error occured while getting grades for school year and term ");
                deferred.reject(error);
            });
            return deferred.promise;
        };

        // This method is to retrieve courses related to school year/term/grade.
        var getSchGradeCourses = function(keycode, schoolId, year, term, grade){
            console.info('In get school grades courses service call');
            console.info('Making a call to service');
            //STT-8742: fetch courses for school year/term/grade
            var schoolGradeCourses = null;
            var deferred = $q.defer();
            var request = $http({
                method: 'GET',
                url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + schoolId + '/getDefaultCourses/' + year + '/' + term + '/' + grade,
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-TOKEN': keycode
                }
            });
            request.then(function (response) {
                console.info('Got all courses for school year/term/grade');
                schoolGradeCourses = response.data;
                deferred.resolve(schoolGradeCourses);
                $rootScope.isSearchCoursesBusy = false;
            }, function (error) {
                console.info("Error occured while getting courses for school year/term/grade ");
                deferred.reject(error);
            });
            return deferred.promise;
        };

            var saveSchoolPartPrograms = function(keycode, schoolId, programList){
                 console.info('In saveSchoolPartPrograms service');
                 console.info('Making a call to service');
                 var result = null;
                 var deferred = $q.defer();
                 var data = programList;

                 var request = $http({
                    method: 'POST',
                    url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint  + schoolId +'/schoolPartPrograms',
                    data : data,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN' : keycode
                    }
                 });
                 request.then(function (response) {
                    result = response.data;
                    deferred.resolve(result);
                    console.info('Saved school Participant programs');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
         };

         
        var saveSchoolDropdownDetails = function(keycode, schoolId, dropdownDetails, type){
                 console.info('In saveSchoolDropdownDetails service');
                 console.info('Making a call to service');
                 var result = null;
                 var deferred = $q.defer();
                 var data = dropdownDetails;

                 var request = $http({
                    method: 'POST',
                    url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + schoolId + '/dropDownDetails/type/' + type,
                    data : data,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN' : keycode
                    }
                 });
                 request.then(function (response) {
                    result = response.data;
                    deferred.resolve(result);
                    console.info('Saved school Dropdown details by type');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
         }; 

        var saveSchoolYearSets = function(keycode, schoolId,  data){
            console.info('In save school years service call');
            console.info('Making a call to service');
            var result = null;
            var deferred = $q.defer();
            var request = $http({ 
                method: 'POST',
                url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + schoolId +'/schoolYear' + (data.schoolYear.id != -1 ? '/' + data.schoolYear.id  : ''),
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-TOKEN': keycode
                },
                data: data
            });
            request.then(function (response) {
                result = response.data;
                deferred.resolve(result);
                console.info('Save the SchoolYearSets');
            }, function (error) {  
                deferred.reject(error);
            });
            return deferred.promise;
        }

        var saveCourseCatalogs = function(keycode,schoolId,schoolYear,xschSchTermId,data){
            console.info('In save course catalogs service call');
            console.info('Making a call to service');
            var result = null;
            var deferred = $q.defer();
            var request = $http({
                method: "POST",
                url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + schoolId + `/catalogCourses/schoolYear/${schoolYear}/schoolTerm/${xschSchTermId}`,
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-TOKEN': keycode
                },
                data: data
            });
            request.then(function(response){
                result = response.data;
                deferred.resolve(result);
                console.info('Save the Course Catalogs');
            }, function(error){
                deferred.reject(error);
            });
            return deferred.promise;
        }

        var saveDefaultCourses = function(keycode, schoolId, schoolYear, xschSchTermId, data){
            console.info('In save default courses service call');
            console.info('Making a call to service');
            var result = null;
            var deferred = $q.defer();
            var request = $http({
                method: "POST",
                url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + schoolId + '/saveDefaultCourses/' + schoolYear + '/' + xschSchTermId,
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-TOKEN': keycode
                },
                data: data
            });
            request.then(function(response){
                result = response.data;
                deferred.resolve(result);
                console.info('Save the Default Courses');
            }, function(error){
                deferred.reject(error);
            });
            return deferred.promise;
        }


        var getSchoolsByActivatedCourseCatalogs = function(keycode){
            console.info('In get schools by activated course catalogs service call');
            console.info('Making a call to service');
            var result = null;
            var deferred = $q.defer();
            var request = $http({
                method: "GET",
                url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + "getSchoolsByActivatedCourseCatalogs",
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-TOKEN': keycode
                }
            });
            request.then(function(response){
                result = response.data;
                deferred.resolve(result);
                console.info('Save the Course Catalogs');
            }, function(error){
                deferred.reject(error);
            });
            return deferred.promise;
        }

        var replicateCatalogCourseChanges = function(keycode,schoolId, schoolYear, xschSchTermIdFrom, listXschSchTermIdsTo,isNewCatalog){
            console.info('In POST to replicate catalog course changes service call');
            console.info('Making a call to service');
            var result = null;
            var deferred = $q.defer();
            var request = $http({
                method: "POST",
                url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + schoolId + "/duplicateCatalog/" + schoolYear +"/" + xschSchTermIdFrom + "?isNewCatalog=" + isNewCatalog,
                data: listXschSchTermIdsTo,
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-TOKEN': keycode
                }
            });
            request.then(function(response){
                result = response.data;
                deferred.resolve(result);
                console.info('Replicate course catalogs');
            }, function(error){
                deferred.reject(error);
            });
            return deferred.promise;
        }

        var getDropdownList = function (keycode, schoolId) {
             console.info('In getDropdownList service');
             console.info('Making a call to service');
             var dataFields = null;
             var deferred = $q.defer();
             var request = $http({  
                 method: 'GET',
                 url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint +'dropDownLists',
                 headers: {
                     'Content-Type': 'application/json',
                     'X-API-TOKEN': keycode
                 }
             });
             request.then(function (response) {
                 dataFields = response.data;
                 deferred.resolve(dataFields);
                 console.info('Got the school dropdown list');
             }, function (error) {  
                 deferred.reject(error);
             });
             return deferred.promise;
            };

        var getAllDropdownTypes = function (keycode, schoolId, type) {
            console.info('In get getAllDropdownTypes service call');
            console.info('Making a call to service');
            var allDropdownType = null;
            var deferred = $q.defer();
            var request = $http({
                method: 'GET',
                url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + schoolId + '/dropDownDetails/type/' + type,
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-TOKEN': keycode
                }
            });
            request.then(function (response) {
                console.info('Got all dropdown list types');
                allDropdownType = response.data;
                deferred.resolve(allDropdownType);
            }, function (error) {
                console.info("Error occured while getting list of getAllDropdownTypes service");
                deferred.reject(error);
            });
            return deferred.promise;
        };

        var getSchoolIntegrationDetails = function (keycode, schoolId) {
            console.info('In get getSchoolIntegrationDetails service call');
            console.info('Making a call to service');
            var allDropdownType = null;
            var deferred = $q.defer();
            var request = $http({
                method: 'GET',
                url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + schoolId + '/integrationDetails',
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-TOKEN': keycode
                }
            });
            request.then(function (response) {
                console.info('Got all dropdown list types');
                allDropdownType = response.data;
                deferred.resolve(allDropdownType);
            }, function (error) {
                console.info("Error occured while getting SchoolIntegrationDetails service");
                deferred.reject(error);
            });
            return deferred.promise;
        };

        var saveSchoolIntegrationDetails = function(keycode, schoolId, data){
            console.info('In save School  Integration details service call');
            console.info('Making a call to service');
            var result = null;
            var deferred = $q.defer();
            var request = $http({
                method: "POST",
                url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + schoolId + '/integrationDetails',
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-TOKEN': keycode
                },
                data: data
            });
            request.then(function(response){
                result = response.data;
                deferred.resolve(result);
                console.info('School Integration Details saved');
            }, function(error){
                deferred.reject(error);
            });
            return deferred.promise;
        }

        var getSchoolCalendar = function (keycode, schoolId, schoolYear) {
            console.info('In get getSchoolCalendar service call');
            console.info('Making a call to service');
            var allDropdownType = null;
            var deferred = $q.defer();
            var request = $http({
                method: 'GET',
                url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + schoolId + '/calendar/' + schoolYear ,
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-TOKEN': keycode
                }
            });
            request.then(function (response) {
                console.info('Got all School Calendar Records');
                allDropdownType = response.data;
                deferred.resolve(allDropdownType);
            }, function (error) {
                console.info("Error occured while getting School Calender service");
                deferred.reject(error);
            });
            return deferred.promise;
        };

        var duplicateSchool = function(keycode, schoolId, data){
            console.info('In school duplication service call');
            console.info('Making a call to service');
            var result = null;
            var deferred = $q.defer();
            var request = $http({
                method: "POST",
                url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + schoolId + '/duplicateSchool',
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-TOKEN': keycode
                },
                data: data
            });
            request.then(function(response){
                result = response.data;
                deferred.resolve(result);
                console.info('School Duplicated successfully');
            }, function(error){
                deferred.reject(error);
            });
            return deferred.promise;
        }

        var getK12CountryStates = function (keycode) {
            console.info('In get getK12CountryStates service call');
            console.info('Making a call to service');
            var allDropdownType = null;
            var deferred = $q.defer();
            var request = $http({
                method: 'GET',
                url: schoolwork12.app.manageSchoolData.endpoints.k12DataEndPoint + 'getStates',
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-TOKEN': keycode
                }
            });
            request.then(function (response) {
                console.info('Got K12 Country States Records');
                allDropdownType = response.data;
                deferred.resolve(allDropdownType);
            }, function (error) {
                console.info("Error occured while getting K12 Country States service");
                deferred.reject(error);
            });
            return deferred.promise;
        };     
        
        var getK12CountryRegions = function (keycode) {
            console.info('In get getK12CountryRegions service call');
            console.info('Making a call to service');
            var allDropdownType = null;
            var deferred = $q.defer();
            var request = $http({
                method: 'GET',
                url: schoolwork12.app.manageSchoolData.endpoints.k12DataEndPoint + 'getRegions',
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-TOKEN': keycode
                }
            });
            request.then(function (response) {
                console.info('Got K12 Country Regions Records');
                allDropdownType = response.data;
                deferred.resolve(allDropdownType);
            }, function (error) {
                console.info("Error occured while getting K12 Country Regions service");
                deferred.reject(error);
            });
            return deferred.promise;
        }; 

        var getK12Billings = function (keycode) {
            console.info('In get getK12Billings service call');
            console.info('Making a call to service');
            var allDropdownType = null;
            var deferred = $q.defer();
            var request = $http({
                method: 'GET',
                url: schoolwork12.app.manageSchoolData.endpoints.k12DataEndPoint + 'getBillings',
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-TOKEN': keycode
                }
            });
            request.then(function (response) {
                console.info('Got K12 Billings Records');
                allDropdownType = response.data;
                deferred.resolve(allDropdownType);
            }, function (error) {
                console.info("Error occured while getting K12 Billings service");
                deferred.reject(error);
            });
            return deferred.promise;
        };

        var getK12SchoolTypes = function (keycode) {
            console.info('In get getK12SchoolTypes service call');
            console.info('Making a call to service');
            var allDropdownType = null;
            var deferred = $q.defer();
            var request = $http({
                method: 'GET',
                url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + 'getSchoolTypes',
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-TOKEN': keycode
                }
            });
            request.then(function (response) {
                console.info('Got K12 School Type Records');
                allDropdownType = response.data;
                deferred.resolve(allDropdownType);
            }, function (error) {
                console.info("Error occured while getting K12 School Type service");
                deferred.reject(error);
            });
            return deferred.promise;
        };

        var getSchoolMainData = function (keycode, schoolId) {
            console.info('In get getSchoolMainData service call');
            console.info('Making a call to service');
            var allDropdownType = null;
            var deferred = $q.defer();
            var request = $http({
                method: 'GET',
                url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + schoolId + '/mainData',
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-TOKEN': keycode
                }
            });
            request.then(function (response) {
                console.info('Got School Main Data');
                allDropdownType = response.data;
                deferred.resolve(allDropdownType);
            }, function (error) {
                console.info("Error occured while getting School Main Data service");
                deferred.reject(error);
            });
            return deferred.promise;
        };

        var saveSchoolMainData = function(keycode, schoolId, data){
            console.info('In Save School Main Data service call');
            console.info('Making a call to service');
            var result = null;
            var deferred = $q.defer();
            var request = $http({
                method: "POST",
                url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + schoolId + '/mainData',
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-TOKEN': keycode
                },
                data: data
            });
            request.then(function(response){
                result = response.data;
                deferred.resolve(result);
                console.info('School Main Data saved successfully');
            }, function(error){
                deferred.reject(error);
            });
            return deferred.promise;
        }

        return {
            getClassroomDates: getClassroomDates,
            searchDeactivatedClassrooms: searchDeactivatedClassrooms,
            saveSchoolDataDetails: saveSchoolDataDetails,
            saveSchoolCTEPrograms: saveSchoolCTEPrograms,
            getDataFields: getDataFields,
            getSchoolMessageFieldTemplates: getSchoolMessageFieldTemplates,
            saveSchoolDataFields: saveSchoolDataFields,
            getAllGradesList: getAllGradesList,
            getAllGradesDetails: getAllGradesDetails,
            saveSchoolGradeMarkSets: saveSchoolGradeMarkSets,
            saveSchoolPartPrograms: saveSchoolPartPrograms,
            getAllSchoolYear: getAllSchoolYear,
            getSchoolTerms: getSchoolTerms,
            getXschSchTerms: getXschSchTerms,
            getXschSchTermsBySchool: getXschSchTermsBySchool,
            getXschSchCourses: getXschSchCourses,
            getXschSchGrades: getXschSchGrades,
            getSchGradeCourses: getSchGradeCourses,
            saveSchoolYearSets: saveSchoolYearSets,
            saveCourseCatalogs: saveCourseCatalogs,
            saveDefaultCourses: saveDefaultCourses,
            getSchoolsByActivatedCourseCatalogs: getSchoolsByActivatedCourseCatalogs,
            replicateCatalogCourseChanges: replicateCatalogCourseChanges,
            getDropdownList: getDropdownList,
            getAllDropdownTypes: getAllDropdownTypes,
            getSchoolIntegrationDetails: getSchoolIntegrationDetails,
            saveSchoolDropdownDetails: saveSchoolDropdownDetails,
            saveSchoolIntegrationDetails: saveSchoolIntegrationDetails,
            getSchoolCalendar: getSchoolCalendar,
            duplicateSchool: duplicateSchool,
            getK12CountryStates: getK12CountryStates,
            getK12CountryRegions: getK12CountryRegions,
            getK12Billings: getK12Billings,
            getK12SchoolTypes: getK12SchoolTypes,
            getSchoolMainData: getSchoolMainData,
            saveSchoolMainData: saveSchoolMainData,
            saveSchoolDropdownDetails: saveSchoolDropdownDetails
        };
    } 

    ]);
}(angular, schoolwork12));
